/**
 * @author Fernando Ruano
 * @file index.js
 * @description Country User Roles Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * Country User Roles Container.
 * @return { Node } React Country User Roles Container.
 */
const CountryUserRolesContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name CountryUserRolesContainer.propTypes
 * @type { Object }
 */
CountryUserRolesContainer.propTypes = {};

/**
 * Default props
 */
CountryUserRolesContainer.defaultProps = {};

export default CountryUserRolesContainer;
